<template>
  <!-- 接收调度员 -->
  <div class="container">
    <!-- 按钮列表 -->
    <div class="glo_btnList" ref="btnList">
      <div class="glo_btnList_left">
        <el-button class="glo_btnItems glo_bgcMainColor" @click="clickAdd"
          >新增</el-button
        >
        <el-button class="glo_btnItems" @click="clickDels">批量删除</el-button>
        <el-dropdown class="topDropDown" @command="topCommandBtns">
          <el-button type="primary">
            更多操作
            <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="dtdc">导出</el-dropdown-item>
            <el-dropdown-item command="bgsz">表格设置</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <queryBtns
        :MoreConditions="MoreConditions"
        @clerBtns="clerBtns"
        @queryBtn_ok="queryBtn_ok"
        @moreParam="moreParam"
      ></queryBtns>
    </div>
    <!-- 查询条件 -->
    <!-- :formData="queryData" -->
    <queryCondition
      ref="queryForm"
      :More="isHaseMore"
      :formConfig="queryCondditionDatas"
    ></queryCondition>
    <!-- 表格 -->
    <div class="glo_Table">
      <el-table
        :height="tableHeigth"
        header-align="center"
        ref="mytable"
        @row-click="rowclick"
        :data="tableData"
        border
        stripe
        :highlight-current-row="true"
        show-summary
        :summary-method="getSummaries"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          fixed="left"
          align="center"
          label="序号"
          type="index"
          width="60"
        ></el-table-column>
        <el-table-column
          fixed="left"
          align="center"
          type="selection"
          width="60"
        ></el-table-column>
        <template v-for="(item, index) in myTableHeard">
          <el-table-column
            :key="index"
            :label="item.name"
            :prop="item.field"
            align="center"
            sortable
            :show-overflow-tooltip="true"
            :min-width="item.width"
            :data-isTotal="item.isTotal"
            v-if="item && item.isShow"
          ></el-table-column>
        </template>
        <el-table-column fixed="right" label="操作" min-width="180px">
          <template slot-scope="scope">
            <div class="tabRightBtns">
              <el-button class="rbtns" @click.stop="clickAdd(scope.row)"
                >修改</el-button
              >
              <!-- 如果按钮超过4个就要用下面这种下拉的样式 -->
              <!-- <el-dropdown
                class="rbtns"
                @command="handleCommandBtns($event, scope.row)"
              >
                <el-button type="primary">
                  更多操作<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="a">详情</el-dropdown-item>
                  <el-dropdown-item command="b">外发录入</el-dropdown-item>
                  <el-dropdown-item command="c">改运单号</el-dropdown-item>
                  <el-dropdown-item command="d">删除</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>-->
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 分页 -->
    <paging
      ref="pags"
      :pageNum="pageStart"
      :total="pageCount"
      :size="pageTotal"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
    ></paging>
    <!--        自定义表头           -->
    <sorttable
      :show_sortTableHeard="show_sortTableHeard"
      :allCheck="allCheck"
      :sortName="sortName"
      :tabelHeadeTitle="tabelHeadeTitle"
      :originalTabelHeadeTitle="originalTabelHeadeTitle"
      :selectLength="selectLength"
      @cancelSortHeard="cancelSortHeard"
      @confirmOk="confirmOk"
      @checktab="checktab"
      @checkAll="checkAll"
      @closeDias="closeDias"
    ></sorttable>

    <!-- 新增修改 -->
    <myDialog
      :diaWidth="diaWidthDispatch"
      :dialogTitle="dialogTitleDispatch"
      :isShowDialog="isShowDialogDispatch"
      @handleCloseDia="handleCloseDiaDispatch"
      @diaCancelBtn="handleCloseDiaDispatch"
      @diaConfirmBtn="diaConfirmBtnDispatch"
    >
      <div class="formbox" v-if="isShowDialogDispatch">
        <el-form class="glo_formBox" label-width="120px">
          <el-form-item label="调度员:">
            <el-select
              v-model="dialogFormDispatch.employeeId"
              placeholder="请选择"
              clearable
              remote
              filterable
              :remote-method="
                (e) => {
                  remoteMethod(e, 'employee', 'employeeList');
                }
              "
              @focus="
                (e) => {
                  focusMethod('employee', 'employeeList');
                }
              "
              @clear="remoteMethod('', 'employee', 'employeeList')"
            >
              <!-- @change="
                (e) => {
                  changeMethod(e, 'storageList', 'intoDeptName');
                }
              "-->
              <el-option
                v-for="(item, index) in employeeList"
                :key="index"
                :label="item.name"
                :value="item.documentId"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="账号:">
            <el-input
              v-model="details.username"
              disabled
              placeholder="自动拉取"
            ></el-input>
          </el-form-item>
          <el-form-item label="排序:">
            <el-input
              v-model="dialogFormDispatch.sort"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item class="textArea" style="width: 100%" label="备注:">
            <el-input
              type="textarea"
              v-model="dialogFormDispatch.remarks"
            ></el-input>
          </el-form-item>
          <el-form-item label="新增人:">
            <el-input
              v-model="details.createUserName"
              disabled
              placeholder="自动拉取"
            ></el-input>
          </el-form-item>
          <el-form-item label="新增时间:">
            <el-input
              v-model="details.createTime"
              disabled
              placeholder="自动拉取"
            ></el-input>
          </el-form-item>
          <el-form-item label="修改人:">
            <el-input
              v-model="details.updateUserName"
              disabled
              placeholder="自动拉取"
            ></el-input>
          </el-form-item>
          <el-form-item label="修改时间:">
            <el-input
              v-model="details.updateTime"
              disabled
              placeholder="自动拉取"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
    </myDialog>

    <!-- 导出插件 -->
    <exportCompoent
      :isShowDialog_dc="isShowDialog_dc"
      :diaWidth_dc="diaWidth_dc"
      :dialogTitle_dc="dialogTitle_dc"
      :dialogForm_dc="dialogForm_dc"
      :tableHeard="EPtableHeard"
      :AllCheck="EPAllCheck"
      :queryCondditionDatas="queryCondditionDatas"
      @checktabEP="checktabEP"
      @checkAllEP="checkAllEP"
      @onAfterEnter="onAfterEnter"
      @handleCloseDia_dc="handleCloseDia_dc"
      @diaConfirmBtn_dc="diaConfirmBtn_dc()"
    >
    </exportCompoent>
  </div>
</template>
<script>
import tableList from "@/pages/tableList.js";
import sorttable from "@/components/sortTemplate.vue"; //自定义排序表头
import paging from "@/components/pagings.vue"; //分页组件
import queryBtns from "@/components/queryBtns.vue";
import queryCondition from "@/components/queryCondition.vue";
import myDialog from "@/components/Dialog.vue";
import exportjs from "@/assets/js/Mixins/exportDT.js"; //导出的公共js
export default {
  mixins: [tableList, exportjs],
  inject: ["reload"],
  components: {
    sorttable,
    paging,
    queryBtns,
    queryCondition,
    myDialog,
  },
  data() {
    return {
      //=======================导出相关 开始 =======================
      dialogForm_dc: {
        pageStart: 1,
        pageTotal: "",
        fileName: "接收调度员", //导出时默认文件名
        apiName: "/v1/common/query/runPageReport", //导出的数据列表接口名(动态列表都是这个)
        EpType: "bdd", //dd==等待下载完成,bdd==不等待完成
        apiType: "POST", //导出当前列表的请求方式
        isJson: 1, // 导出当前列表的请求头是否json
      },
      //=======================导出相关 结束 =======================
      pageGroupName: "DispatchCar_ReceivingDispatcher", //  页面标识
      reportFiledsNumber: "disptch_user_list", // 动态 条件、表头

      isShowDialogDispatch: false,
      dialogTitleDispatch: "新增",
      diaWidthDispatch: "60%",
      dialogFormDispatch: {
        sort: "",
        remarks: "",
        employeeId: "",
      },
      employeeList: [],
      details: {},
    };
  },
  mounted() {},
  watch: {},
  methods: {
    async clickAdd(row) {
      this.dialogFormDispatch = {
        sort: "",
        remarks: "",
        employeeId: "",
      };
      this.details = row || {};
      if (row.id) {
        this.dialogTitleDispatch = "编辑";
        this.dialogFormDispatch.id = row.id || "";
        this.dialogFormDispatch.sort = row.sort || "";
        this.dialogFormDispatch.remarks = row.remarks || "";
        await this.remoteMethod(row.employeeName, "employee", "employeeList");
        this.dialogFormDispatch.employeeId = String(row.employeeId);
      } else {
        this.dialogTitleDispatch = "新增";
      }
      this.isShowDialogDispatch = true;
    },
    handleCloseDiaDispatch() {
      this.isShowDialogDispatch = false;
      this.dialogFormDispatch = {
        sort: "",
        remarks: "",
        employeeId: "",
      };
    },
    //  弹窗确认保存事件
    diaConfirmBtnDispatch() {
      if (this.dialogFormDispatch.id) {
        this.$API.updateDispatchUser(this.dialogFormDispatch).then((res) => {
          this.$message.success(res.data.message || "操作成功");
          this.isShowDialogDispatch = false;
          this.getData();
        });
      } else {
        this.$API.addDispatchUser(this.dialogFormDispatch).then((res) => {
          this.$message.success(res.data.message || "操作成功");
          this.isShowDialogDispatch = false;
          this.getData();
        });
      }
    },
    clickDels() {
      let ids = [];
      if (this.selectTableData.length < 1) {
        this.$message.error("请至少选择一条数据进行操作");
        return false;
      }
      this.selectTableData.forEach((item) => {
        ids.push(item.id);
      });
      this.$confirm("确定要删除所选数据吗? 请谨慎操作", "提示:")
        .then((res) => {
          this.$API.delDispatchUser({ ids }).then((res) => {
            this.$message.success(res.data.message || "操作成功");
            this.getData();
          });
        })
        .catch((err) => {});
    },
    //员工、部门、外发网点
    focusMethod(key, keys) {
      console.log(this.dialogFormDispatch.employeeId);
      if (this[keys].length == 0) {
        this.remoteMethod("", key, keys);
      }
    },
    // //员工、部门、外发网点
    // changeMethod(e, arrs, keys) {
    //   let curs = this[arrs].filter((item) => item.documentId == e);
    //   if (keys == "intoDeptName") {
    //     this.rukuPlanReq[keys] = (curs.length && curs[0].name) || "";
    //   } else {
    //     this.commandReq[keys] = (curs.length && curs[0].name) || "";
    //   }
    // },
    // 员工、部门、外发网点
    remoteMethod(name, key, keys) {
      // employee 员工
      // dept 部门
      // storage 外发网点
      return this.$API
        .wtl_getObjectUserDownList({
          name,
          key,
          pageStart: 1,
          pageTotal: 20,
        })
        .then((res) => {
          let arrs = res.data.result.data || [];
          this[keys] = arrs;
        });
    },
  },
};
</script>
<style scoped lang="less">
.textArea {
  height: auto !important;
}
</style>